<template>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="name">Nama </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="name">Nomor Telepon </label>
                <input type="text" v-model="model.phone_number" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    components: {},
    props: {
        detail: {
            type: Object,
            default: () => ({
                name: '',
                phone_number: '',
                id: '',
            })
        }
    },
    data() {
        return {
            model: {
                name: this.detail?.name,
                id: this.detail?.id,
                phone_number: this.detail?.phone_number,
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', phone_number: '' }
        }
    },
    watch: {
        detail: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.model = {
                    name: newVal?.name || '',
                    id: newVal?.id || '',
                    phone_number: newVal?.phone_number || '',
                }
            }
        }
    }
}
</script>